module.exports = __webpack_public_path__ + "static/media/playlist-reorder.2ffd8404.svg";